module.exports = __webpack_public_path__ + "img/Header-Iottly-600x160.6e9dde57.png";